module.exports = __webpack_public_path__ + "img/20230713135519549qx8.4132bc9f.jpg";